import { render, staticRenderFns } from "./StandardPausedMenu.vue?vue&type=template&id=6cc65ec6&scoped=true&"
import script from "./StandardPausedMenu.vue?vue&type=script&lang=js&"
export * from "./StandardPausedMenu.vue?vue&type=script&lang=js&"
import style0 from "./StandardPausedMenu.vue?vue&type=style&index=0&id=6cc65ec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc65ec6",
  null
  
)

export default component.exports